// Registra Service Worker — necessário para Push Notifications (Web Push).
// Em produção é necessário HTTPS; em dev funciona em localhost.
//
// Importante: tentamos forçar update() a cada carregamento da página para que
// mudanças no sw.js (defaults de ícone, novos handlers etc.) cheguem ao usuário
// sem precisar de hard-reload manual.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/sw.js`;
    try {
      const reg = await navigator.serviceWorker.register(swUrl, { updateViaCache: "none" });
      reg.addEventListener("updatefound", () => {
        const installing = reg.installing;
        if (!installing) return;
        installing.addEventListener("statechange", () => {
          if (installing.state === "activated" && navigator.serviceWorker.controller) {
            window.location.reload();
          }
        });
      });
      reg.update().catch(() => {});
    } catch (e) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[SW] Não foi possível registrar:", e?.message || e);
      }
    }
  });
}
